"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUriTitleProperty = exports.uriTitlePropertyDefinition = void 0;
exports.uriTitlePropertyDefinition = {
    view: {
        label: 'URI title',
        hint: 'Displayed at the end of the URL. Keep it short with the keywords in the beginning, eg \'rampage- 2016 - results\'. The following characters won\'t be accepted: # % ? & / ,',
    },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'maxLength',
            argument: 250,
        },
        {
            name: 'pattern',
            argument: '^[^#%?&/,]*$',
        },
    ],
    type: 'text',
    multiple: false,
    name: 'uri-title',
};
const isUriTitleProperty = (prop) => {
    return prop.name === exports.uriTitlePropertyDefinition.name;
};
exports.isUriTitleProperty = isUriTitleProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXJpLXRpdGxlLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvdXJpLXRpdGxlLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsMEJBQTBCLEdBQUc7SUFDeEMsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLFdBQVc7UUFDbEIsSUFBSSxFQUFFLDZLQUE2SztLQUNwTDtJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLElBQUk7U0FDZjtRQUNEO1lBQ0UsSUFBSSxFQUFFLFdBQVc7WUFDakIsUUFBUSxFQUFFLEdBQUc7U0FDZDtRQUNEO1lBQ0UsSUFBSSxFQUFFLFNBQVM7WUFDZixRQUFRLEVBQUUsY0FBYztTQUN6QjtLQUNGO0lBQ0QsSUFBSSxFQUFFLE1BQU07SUFDWixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxXQUFXO0NBQ2MsQ0FBQTtBQUkxQixNQUFNLGtCQUFrQixHQUFHLENBQUMsSUFBa0IsRUFBNEIsRUFBRTtJQUNqRixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssa0NBQTBCLENBQUMsSUFBSSxDQUFBO0FBQ3RELENBQUMsQ0FBQTtBQUZZLFFBQUEsa0JBQWtCLHNCQUU5QiJ9